<template>
  <div class="heading">
    <h5>MINUTES - OA系统</h5>
    <p>
      <i class="el-icon-s-custom user" @mouseover="showPasswordFn" @mouseout="closePasswordFn"></i>
      <span>{{user.nickname}}，上次登录时间 {{user.update_time}}</span>
      <i class="el-icon-switch-button logout" @click="logout"></i>
      <!-- 0819修改：新增暗色切换按钮 -->
      <button class="themetoggle" :title="isDark ? '切换到浅色模式' : '切换到暗色模式'" @click="toggleTheme">
        <svg v-if="isDark" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2m0 16v2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M2 12h2m16 0h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>
        <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>
      </button>
      <span class="items" v-show="showPassword">
        <span class="item" @click="toChange">修改密码</span>
      </span>
    </p>
  </div>
</template>

<script>
  // import * as api from '@/api'
  export default {
  data() {
    return {
      user: JSON.parse(localStorage.getItem('setUserInfo')) || {},
      showPassword: false,
      isDark: document.documentElement.classList.contains('dark') /* 0819修改 */
    }
  },

  methods: {
    // 0819修改：新增主题切换方法
    toggleTheme() {
      const root = document.documentElement
      root.classList.toggle('dark')
      this.isDark = root.classList.contains('dark')
      localStorage.setItem('oa-theme', this.isDark ? 'dark' : 'light')
      window.dispatchEvent(new Event('theme-change')) // 0819修改：通知表格重新布局
    },
    logout() {
        // api.logout().then(res => {
        //   if (res.status === 200) this.$router.push('/login')
        // })
        this.$store.dispatch('user/logout')
      },
      showPasswordFn() {
        // console.log(this.user.id);
        this.showPassword = true
      },
      closePasswordFn() {
        setTimeout(() => {
          this.showPassword = false
        }, 2000);
      },
      toChange() {
        this.$router.push({ path: '/author/change?id=' + this.user.id })
      }
    },
  }
</script>

<style lang="scss" scoped>
  .heading {
    @extend %center;
    justify-content: space-between;
    background: var(--card); /* 0819修改 */
    height: 80px;
    padding: 0 20px;
    flex-flow: row nowrap;
    transition: var(--transition); /* 0824新增 */

    h5 {
      font-size: 24px;
      color: var(--header); /* 0819修改 */
      transition: var(--transition); /* 0824新增 */
    }

    p {
      padding: 0 20px 0 0;
      @extend %center;
      flex-flow: row nowrap;
      position: relative;

      .user {
        width: 48px;
        height: 48px;
        font: 38px/48px arial;
        background: $c;
        color: #fff;
        border-radius: 50%;
        transition: var(--transition); /* 0824新增 */
        cursor: pointer; /* 0824新增 */

        &:hover {
          transform: scale(1.08); /* 0824新增：头像 hover 放大 */
          box-shadow: 0 0 0 4px rgba(14, 15, 34, 0.1); /* 0824新增：光环效果 */
        }
      }

      span {
        color: var(--text-1); /* 0819修改 */
        font-size: 14px;
        letter-spacing: 3px;
        padding: 0 20px;
        transition: var(--transition-fast); /* 0824新增 */
      }

      .logout {
        width: 24px;
        height: 24px;
        margin-right: 24px;
        color: #fdb4b2;
        font: 24px/1 arial;
        transition: var(--transition); /* 0824新增 */
        cursor: pointer; /* 0824新增 */

        &:hover {
          transform: scale(1.15); /* 0824新增 */
        }
        &:active {
          transform: scale(0.95); /* 0824新增 */
        }
      }

      /* 0819修改：新增切换按钮样式 */
      .themetoggle {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: 1px solid var(--border);
        background: transparent;
        color: var(--text-1);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        outline: none;
        transition: var(--transition); /* 0824修改：统一过渡 */

        &:hover {
          border-color: var(--accent);
          color: var(--accent);
          transform: scale(1.1); /* 0824新增 */
          box-shadow: 0 0 0 3px rgba(135, 136, 193, 0.15); /* 0824新增 */
        }
        &:active {
          transform: scale(0.95); /* 0824新增 */
        }
        svg {
          transition: var(--transition-fast); /* 0824新增：图标旋转过渡 */
        }
      }

      .items {
        display: block;
        width: 120px;
        padding: 0;
        border-radius: var(--radius-md); /* 0824修改：5px → 8px */
        background: var(--card); /* 0819修改 */
        box-shadow: var(--shadow); /* 0819修改 */
        border: 1px solid var(--border); /* 0819修改 */
        position: absolute;
        top: 45px;
        left: 20px;
        animation: dropdownFadeIn 0.2s ease; /* 0824新增：下拉入场动画 */
        .item {
          display: block;
          font-size: 14px;
          text-align: center;
          padding: 2px 5px;
          cursor: pointer;
          z-index: 99;
          color: var(--text-1); /* 0819修改 */
          border-radius: var(--radius-sm); /* 0824新增 */
          margin: 2px 4px; /* 0824新增 */
          transition: var(--transition-fast); /* 0824新增 */

          &:hover {
            background: var(--bg-soft); /* 0824新增：hover 浮层 */
          }
        }
      }
    }
  }

  /* 0824新增：下拉菜单入场动画 */
  @keyframes dropdownFadeIn {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>